import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { editContent } from '../../modules/editor';

import FieldSection from './FieldSection';

import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useAlert from '../../hooks/useAlert';
import useDebounce from '../../hooks/useDebounce';
import { sanitizeHtml, validHtml } from '../../util/html';

type Props = {
	selectedContentId: number;
	currentContent: any;
}

function SelectedContentHtmlcode({ selectedContentId, currentContent }: Props) {
	const dispatch = useDispatch();
	const Alert = useAlert();
	const [isHtmlValid, setIsHtmlValid] = useState(true);
	const [isToastShown, setIsToastShown] = useState(false);

	const [debounceCode, code, setCode] = useDebounce<string>(
		currentContent?.content?.content[0]?.text,
		100
	);

	const codeBeforeSave = useRef(code);

	const onChange = (e: any) => {
		const { value } = e.target;
		if (!isToastShown && !validHtml(value)) {
			Alert.error(Alert?.msg?.CHECK_HTML_CODE);
			setIsToastShown(true);
			setTimeout(() => {
				setIsToastShown(false);
			}, 3000);
		}
		setCode(value);
	}

	const onBlur = () => {
		if (codeBeforeSave.current === code) return;
		dispatch(editContent({ target: `${selectedContentId}/content/0/text`, data: sanitizeHtml(code), mode: 'force' }));
		codeBeforeSave.current = code;
	}

	useEffect(() => {
		setCode(currentContent?.content?.content[0]?.text);
	}, [selectedContentId]);

	useEffect(() => {
		dispatch(editContent({ target: `${selectedContentId}/content/0/text`, data: code }));
	}, [debounceCode]);

	useEffect(() => {
		setIsHtmlValid(validHtml(code));
	}, [code]);

	return (
		<div className="editor-sidebar-selected-content-setting">
			<div className="description">
				<h1>
					이렇게 사용하세요.
				</h1>
				<p>
					HTML 코드 상자를 추가하면 이메일 콘텐츠를 코드로 만들 수 있습니다. <a href="https://help.stibee.com/email/edit/html" target="_blank">HTML 코드 상자 사용 방법</a>		
				</p>
			</div>
			<FieldSection
				labelName=""
				label={false}
			>
				<div className="htmlcode-field">
					<textarea
						className={isHtmlValid ? '' : 'invalid-html'}
						value={code}
						onChange={onChange}
						onBlur={onBlur}
					></textarea>
				</div>
			</FieldSection>
			{!isHtmlValid && (
				<div className='invalid-html-tag'>
					<p><FontAwesomeIcon className='info-icon' icon={faCircleExclamation} />지원되지 않는 태그는 코드 상자에 저장되지 않습니다.</p>
					<p>
						{"<html>, <head>, <body>, <style>, <script>, <iframe>, <audio>, <video>, <embed>, <object>, <noscript>, <meta>, <form>, <input>, <button>"}
					</p>
				</div>
			)}
		</div >
	);
}

export default SelectedContentHtmlcode;